import JSZip from 'jszip'
import { maxXlzSize } from '@ps/utils/config'
import { getImgMsg } from '@com/utils/zip-file'

export async function isXlzZip(file: File): Promise<boolean> {
  // 解析zip包
  return new Promise((resolve, reject) => {
    const zip = new JSZip()
    zip
      .loadAsync(file)
      .then(function (zip) {
        const files = Object.values(zip.files)
        const fileDirNames = files.filter((fileItem) => {
          return fileItem.dir && !/^(__MACOSX)|(\.DS_Store)/.test(fileItem.name)
        })

        // 存在两个文件夹的情况下为普通zip文件
        if (fileDirNames.length > 1) {
          resolve(false)
          return
        }

        const fileNamesList = files.filter((fileItem) => {
          return (
            !fileItem.dir && !/^(__MACOSX)|(\.DS_Store)/.test(fileItem.name)
          )
        })

        if (
          !fileNamesList.every((file) => file.name.endsWith('.png')) ||
          (fileDirNames.length === 1 &&
            !fileNamesList.every((file) =>
              file.name.startsWith(fileDirNames[0]!.name),
            ))
        ) {
          resolve(false)
        } else {
          resolve(true)
        }
      })
      .catch((err) => {
        reject(new Error(err.message))
      })
  })
}

export async function validateXlzZip(file: File) {
  if (file.size > maxXlzSize * 1024 * 1024) {
    return {
      valid: false,
      rule: 'size',
    }
  }
  if (!(await isXlzZip(file))) {
    return {
      valid: false,
      rule: 'format',
    }
  }
  return {
    valid: true,
  }
}

export async function isSameImageSizeXlz(file: File) {
  const zip = await JSZip.loadAsync(file)
  const files = Object.keys(zip.files)
  const fileNamesList = files.filter((fileName) => {
    return !fileName.startsWith('__MACOSX') && !zip.files[fileName]?.dir
  })
  let validate = true
  const imgInfo: any[] = []
  const data = await Promise.all(
    fileNamesList
      .map((fileName) => zip.file(fileName)!.async('base64'))
      .filter(Boolean),
  )
  for (let i = 0; i < data.length; i++) {
    const imgMsg = await getImgMsg(data[i])
    if (!i) {
      imgInfo.push(imgMsg)
    }
    // 判断序列帧图片尺寸是否一致，尺寸不一致表示序列帧文件异常
    if (
      i &&
      (imgMsg.width !== imgInfo[0].width || imgMsg.height !== imgInfo[0].height)
    ) {
      validate = false
      break
    }
  }
  return validate
}

export async function getImageListByZip(file: File) {
  const zip = await JSZip.loadAsync(file)
  const files = Object.keys(zip.files)
  const fileNamesList = files.filter((fileName) => {
    return !fileName.startsWith('__MACOSX') && !zip.files[fileName]?.dir
  })
  return fileNamesList
}
